import React from 'react';

const ThemeContext = React.createContext({
  themeContext: '',
  nativeRouteName: '',
  guestLocation: {},
  fetchingLocation: false,
  locationPermissionStatus: '',
  requestPartnerLocation: () => {},
});

export default ThemeContext;
